import { Chip } from "@mui/material";
import SpriteIcon from "../../../../../../core-components/assets/Icon";
import { Christine, Greeny, Neutrals, SemanticError, SemanticInfo } from "../../../../../../core-components/theme/color-palette/colors";



export const getEventTagIcon = (tag: string) => {
    switch (tag.toLowerCase()) {
      case 'starttag':
        return <SpriteIcon id="event_start_icon" width={20} height={20} />;
      case 'eventtag':
        return <SpriteIcon id="event_reference_icon" width={20} height={20} />;
      case 'endtag':
        return <SpriteIcon id="event_end_icon" width={20} height={20} />;
      default:
        return <SpriteIcon id="event_reference_icon" width={20} height={20} />;
    }
  };

export const renderEquipmentChip = (option: any, tagProps: any, extraStyles?: any) => {
  let styles = {};
  let icon = null;
  switch (option?.equipmentType?.toLowerCase()) {
    case "tank":
      icon = <SpriteIcon id="tank_type_icon" width={16} height={16} />;
      styles = {
        borderColor: SemanticInfo[900],
        backgroundColor:"#fff",
        color: SemanticInfo[600],
        "& .MuiChip-deleteIcon": {
          color :  Neutrals[200],
        },
      };
      break;

    case "blower":
      icon = <SpriteIcon id="blower_type_icon" width={16} height={16} />;
      styles = {
        borderColor: "#BDBDBD",
        backgroundColor:"#fff",
        color: Neutrals[600],
        "& .MuiChip-deleteIcon": {
          color :  Neutrals[200],
        },
      };
      break;

    case "pump":
      icon = <SpriteIcon id="pump_type_icon" width={16} height={16} />;
      styles = {
        borderColor: Christine[900],
        backgroundColor:"#fff",
        color: Christine[600],
        "& .MuiChip-deleteIcon": {
          color :  Neutrals[200],
        },
      };
      break;

    case "filter":
      icon = <SpriteIcon id="filter_type_icon" width={16} height={16} />;
      styles = {
        borderColor: Greeny[900],
        backgroundColor:"#fff",
        color: Greeny[600],
        "& .MuiChip-deleteIcon": {
          color :  Neutrals[200],
        },
      };
      break;

    case "plant":
      icon = <SpriteIcon id="plant_type_icon" width={16} height={16} />;
      styles = {
        borderColor: Neutrals[900],
        backgroundColor:"#fff",
        color: Neutrals[900],
        "& .MuiChip-deleteIcon": {
          color : Neutrals[200],
        },
      };
      break;

      case "valve":
      icon = <SpriteIcon id="valve_type_icon" width={16} height={16} />;
      styles = {
        borderColor: SemanticError[900],
        backgroundColor:"#fff",
        color: SemanticError[600],
        "& .MuiChip-deleteIcon": {
          color :  Neutrals[200],
        },
      };
      break;

    default:
      icon = <SpriteIcon id="pump_type_icon" width={16} height={16} />;
      styles = {
        borderColor: Christine[900],
        backgroundColor:"#fff",
        color: Christine[600],
        "& .MuiChip-deleteIcon": {
          color :  Neutrals[200],
        },
      };
  }

  return (
    <Chip
      key={option.equipmentId}
      label={option.equipmentName}
      icon={icon}
      sx={{
        border: "1px solid",
        ...styles,
        ...extraStyles
      }}
      {...tagProps}
    />
  );
};
